import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BaseAPIArray,
  BaseAPIObject,
  BaseApiService,
} from '../services/base-api.service';
import { HelpersService } from '../services/helpers.service';
import { ProgressService } from '../services/progress.service';
import { LoadingService } from '../services/loading.service';
import { share } from 'rxjs';
import { HttpQuery } from '../services/http-query';

@Injectable({
  providedIn: 'root',
})
export class ReportService extends BaseApiService<any> {
  constructor(
    public override http: HttpClient,
    public override helper: HelpersService,
    public override loading: ProgressService,
    public override loadingService: LoadingService
  ) {
    super(http, helper, loading, loadingService);
    this.endpoint = 'report';
    this.query = { limit: 0, page: 0 };
  }

  getAllReport(data: any, notifyChange: Boolean = true): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('find/paginate');
      this.loadingService.startLoading();
      this.http.post<BaseAPIObject<any>>(url, data).subscribe({
        next: ({ data, meta }) => {
          this.data = data;
          this.dataLength = meta?.totalData;
          if (notifyChange) {
            this.onDataChanged.next(this.data);
            this.onDataLengthChanged.next(this.dataLength);
          }
          this.loadingService.endLoading();
          return resolve(this.data);
        },
        error: (err) => this.handleError(err, reject),
      });
    });
  }

  generate(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('export-excel');
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: (res) => {
            this.loadingService.endLoading();
            if (!res?.success) {
              return reject({ message: res?.message ?? 'Failed to generate Excel' });
            }
            return resolve(res.data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }

  getFinalTransactionRecap(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('final-transaction-recap');
      this.loadingService.startLoading();
      this.http.post<BaseAPIObject<any>>(url, data).subscribe({
        next: ({ data, meta }) => {
          this.data = data?.reports ?? [];
          this.dataLength = meta?.totalData ?? 0;
          this.onDataChanged.next(this.data);
          this.onDataLengthChanged.next(this.dataLength);
          this.loadingService.endLoading();
          return resolve({ ...(data ?? {}), meta });
        },
        error: (err) => this.handleError(err, reject),
      });
    });
  }

  exportFinalTransactionRecap(data: { search?: string }): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('final-transaction-recap/export-excel');
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: (res) => {
            this.loadingService.endLoading();
            if (!res?.success) {
              return reject({
                message: res?.message ?? 'Failed to export Excel',
              });
            }
            return resolve(res.data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
}
